import { render, staticRenderFns } from "./avgSpanTime.vue?vue&type=template&id=a5ae8f00&"
import script from "./avgSpanTime.vue?vue&type=script&lang=js&"
export * from "./avgSpanTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports